import type { Messages } from '../i18n.types'

/** French admin UI strings (ADR-043). */
export const fr: Messages = {
  common: {
    breadcrumb: "Fil d'Ariane",
    loading: 'Chargement',
    somethingWrong: 'Une erreur est survenue',
    reference: 'Référence : {id}',
    dismiss: 'Fermer',
    close: 'Fermer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    delete: 'Supprimer',
    remove: 'Retirer',
    save: 'Enregistrer',
    saving: 'Enregistrement…',
    create: 'Créer',
    edit: 'Modifier',
    search: 'Recherche',
    type: 'Type',
    status: 'Statut',
    all: 'Tous',
    yes: 'Oui',
    no: 'Non',
    untitled: 'Sans titre',
    previous: 'Précédent',
    next: 'Suivant',
    total: '{count} au total',
    range: '{from}–{to} sur {total}',
    selected: '{count} sélectionné(s)',
    selectItem: 'Sélectionner {name}',
    name: 'Nom',
    key: 'Clé',
    description: 'Description',
    actions: 'Actions',
    updated: 'Modifié',
    created: 'Créé',
    version: 'Version',
    language: 'Langue',
    languages: 'Langues',
    allLanguages: 'Toutes les langues',
    refresh: 'Actualiser',
    back: 'Retour',
    open: 'Ouvrir',
    none: 'Aucun',
    email: 'E-mail',
    password: 'Mot de passe',
    displayName: "Nom d'affichage",
    enabled: 'Activé',
    disabled: 'Désactivé',
    details: 'Détails',
    filter: 'Filtre',
    clear: 'Effacer',
    view: 'Voir',
  },
  list: {
    any: 'Tous',
    filters: 'Filtres',
    results: '{count} résultats',
    resultOne: '1 résultat',
    clear: 'Effacer les filtres',
    removeFilter: 'Retirer le filtre : {name}',
    since: 'depuis le {day}',
    until: 'jusqu’au {day}',
    min: 'Min.',
    max: 'Max.',
    from: 'Du',
    to: 'Au',
    range: '{first}–{last} sur {total}',
    perPage: 'Par page',
    pages: 'Pages',
    noneMatch: 'Rien ne correspond aux filtres',
    noneMatchHelp: 'Modifiez ou effacez les filtres pour en voir davantage.',
  },
  nav: {
    dashboard: 'Tableau de bord',
    content: 'Contenu',
    media: 'Médias',
    contentTypes: 'Types de contenu',
    plugins: 'Extensions',
    users: 'Utilisateurs',
    roles: 'Rôles',
    audit: "Journal d'audit",
    groupContent: 'Contenu',
    groupBuild: 'Construction',
    groupAdmin: 'Administration',
    mail: 'E-mail',
    backup: 'Sauvegarde',
    website: 'Site web',
  },
  crumbs: {
    content: 'Contenu',
    newEntry: 'Nouvelle entrée',
    edit: 'Modifier',
    contentTypes: 'Types de contenu',
    builder: 'Éditeur',
    media: 'Médias',
    users: 'Utilisateurs',
    roles: 'Rôles',
    plugins: 'Extensions',
    details: 'Détails',
    extension: 'Extension',
    audit: "Journal d'audit",
    settings: 'Paramètres',
    mail: 'E-mail',
    backup: 'Sauvegarde',
    website: 'Site web',
  },
  // English until translated.
  mail: {
    kicker: 'Settings',
    title: 'E-mail',
    lead: 'One SMTP account for every e-mail of the CMS and its plugins. A plugin can use its own SMTP account instead.',
    cmsTitle: 'CMS SMTP',
    effective: 'In use: {source}',
    sourceDatabase: 'the settings below',
    sourceEnvironment: 'the server configuration (SMTP_HOST {host})',
    sourceLog: 'none — e-mails are only written to the log',
    emptyHelp:
      'Leave the host empty to use the server configuration (SMTP_* variables).',
    host: 'SMTP host',
    port: 'Port',
    security: 'Encryption',
    securityNone: 'STARTTLS / none',
    securityTls: 'SSL/TLS',
    username: 'User name',
    password: 'Password',
    passwordKeep: 'Saved — leave empty to keep it',
    removePassword: 'Remove the saved password',
    fromName: 'Sender name',
    fromAddress: 'Sender address',
    fromOptional: 'Empty = the CMS sender',
    replyTo: 'Reply-to address (optional)',
    save: 'Save',
    saved: 'E-mail settings saved',
    testTitle: 'Send a test e-mail',
    testTo: 'Recipient',
    testSend: 'Send test',
    testSent: 'Test e-mail sent ({account})',
    testLogged:
      'No SMTP configured: the test e-mail was only written to the log',
    testFailed: 'Sending failed: {error}',
    pluginsTitle: 'Plugin SMTP accounts',
    pluginsLead:
      'Plugins send through the CMS SMTP unless they have their own account here.',
    plugin: 'Plugin',
    account: 'Account',
    usesCms: 'CMS SMTP',
    ownAccount: 'Own: {host}',
    ownDisabled: 'Own (off): {host}',
    configure: 'Own SMTP',
    edit: 'Edit',
    remove: 'Remove',
    removeConfirm:
      'Remove the SMTP account of {plugin}? It will send through the CMS SMTP again.',
    removed: 'Plugin SMTP account removed',
    pluginDialog: 'SMTP account for {plugin}',
    enabled: 'Use this account for the plugin’s e-mails',
    noPlugins: 'No plugins installed',
    deliveriesTitle: 'Recent e-mails',
    deliveriesEmpty: 'No e-mails sent yet',
    time: 'Time',
    source: 'Sender',
    to: 'To',
    subject: 'Subject',
    status: 'Status',
    statusSENT: 'Sent',
    statusFAILED: 'Failed',
    statusLOGGED: 'Logged only',
    accountplugin: 'plugin SMTP',
    accountcms: 'CMS SMTP',
    accountenvironment: 'server SMTP',
    accountlog: 'log',
    deliveriesSearch: 'Destinataire ou objet',
  },
  notifications: {
    title: 'Notifications',
    unseen: '{count} nouvelle(s)',
    empty: 'Aucune notification pour le moment.',
    markAllRead: 'Tout marquer comme lu',
    dismiss: 'Ignorer',
    soundOn: 'Activer le son des notifications',
    soundOff: 'Désactiver le son des notifications',
    sources: {
      content: 'Contenu',
      admin: 'Administrateur',
      identity: 'Comptes',
      media: 'Médias',
      plugins: 'Extensions',
    },
  },
  shell: {
    mainNavigation: 'Navigation principale',
    home: 'Accueil GX-CMS',
    noRole: 'Aucun rôle',
    lightTheme: 'Passer au thème clair',
    darkTheme: 'Passer au thème sombre',
    signOut: 'Se déconnecter',
    openNavigation: 'Ouvrir la navigation',
    filterMenu: 'Filtrer le menu',
    noMenuMatches: 'Aucune page correspondante',
    expandAll: 'Développer tous les groupes',
    collapseAll: 'Réduire tous les groupes',
    resizeNavigation:
      'Redimensionner la navigation : faites glisser ou utilisez les flèches ; double-clic ou Entrée pour réinitialiser',
    collapseNavigation: 'Réduire la navigation aux icônes',
    expandNavigation: 'Développer la navigation',
    language: 'Langue',
    accessDenied: 'Accès refusé',
    accessDeniedText:
      "Vous n'avez pas l'autorisation d'afficher cette page. Demandez l'accès à un administrateur.",
    notFound: 'Page introuvable',
    notFoundText: "La page que vous cherchez n'existe pas.",
  },
  fields: {
    invalidJson: 'JSON invalide',
    missingFile: 'Fichier manquant',
    addMedia: 'Ajouter des médias',
    chooseMedia: 'Choisir des médias',
    missingEntry: 'Entrée manquante',
    unlink: 'Délier',
    linkMore: "Lier d'autres entrées",
    linkEntry: 'Lier une entrée',
    removeItem: "Retirer l'élément",
    addItem: 'Ajouter un élément',
    linkEntries: 'Lier des entrées',
    link: 'Lier',
    allAllowedTypes: 'Tous les types autorisés',
    noMatchingEntries: 'Aucune entrée correspondante',
  },
  confirm: {
    stillInUse: 'Toujours utilisé',
    andMore: '…et {count} de plus',
    deleteAnyway: 'Supprimer quand même',
    typeToConfirm: 'Saisissez {text} pour confirmer',
  },
  actor: {
    system: 'Système',
    you: 'Vous',
    service: 'Service · {name}',
    plugin: 'Extension · {name}',
    user: 'Utilisateur {id}',
  },
  status: {
    PUBLISHED: 'publié',
    ACTIVE: 'actif',
    ENABLED: 'activé',
    READY: 'prêt',
    SUCCESS: 'succès',
    HEALTHY: 'opérationnel',
    DRAFT: 'brouillon',
    INSTALLED: 'installé',
    IN_REVIEW: 'en relecture',
    SCHEDULED: 'planifié',
    PROCESSING: 'en traitement',
    UPLOADING: 'en téléversement',
    INVITED: 'invité',
    DISCOVERED: 'découvert',
    ARCHIVED: 'archivé',
    DISABLED: 'désactivé',
    DELETED: 'supprimé',
    UNKNOWN: 'inconnu',
    FAILED: 'échoué',
    FAILURE: 'échec',
    LOCKED: 'verrouillé',
    UNHEALTHY: 'défaillant',
    PENDING: 'en attente',
  },
  auth: {
    hero: 'Le contenu, {em}',
    heroEm: 'sous contrôle.',
    sub: 'GX-CMS — contenus structurés, révisions et publication pour chaque canal.',
    welcome: 'Bon retour',
    signIn: 'Se connecter',
    failed: 'Échec de la connexion',
  },
  dashboard: {
    morning: 'Bonjour',
    afternoon: 'Bon après-midi',
    evening: 'Bonsoir',
    lead: 'Ce qui se passe dans vos contenus.',
    newEntry: 'Nouvelle entrée',
    entries: 'Entrées',
    published: 'Publiées',
    drafts: 'Brouillons',
    inReview: 'En relecture',
    scheduled: 'Planifiées',
    recent: 'Modifiées récemment',
    viewAll: 'Tout voir',
    noContent: 'Aucun contenu pour l’instant',
    noContentText: 'Créez votre première entrée pour la voir ici.',
    awaitingReview: 'En attente de relecture',
    nothingReview: 'Rien en attente de relecture.',
    noScheduled: 'Aucune publication planifiée.',
    fromPlugins: 'Depuis vos extensions',
    byLanguage: 'Entrées par langue',
  },
  entries: {
    drafts: 'Brouillons',
    inReview: 'En relecture',
    scheduled: 'Planifiées',
    published: 'Publiées',
    archived: 'Archivées',
    liveIn: 'En ligne en {language}',
    draftIn: 'Brouillon en {language} (non publié dans cette langue)',
    createEntry: 'Créer une entrée',
    noActiveTypes: 'Aucun type de contenu actif',
    noActiveTypesText: 'Activez un type de contenu avant de créer des entrées.',
    deleteCount: {
      one: 'Supprimer {count} entrée ?',
      other: 'Supprimer {count} entrées ?',
    },
    deleteText:
      'Les entrées sélectionnées et leur historique de versions sont supprimés définitivement. Les pages publiées disparaissent du site. Cette action est irréversible.',
    stillReferenced: 'Certaines entrées sont encore référencées',
    referencedText: {
      one: "{count} entrée est liée depuis d'autres entrées. Supprimer quand même et retirer ces liens ?",
      other:
        "{count} entrées sont liées depuis d'autres entrées. Supprimer quand même et retirer ces liens ?",
    },
    deleted: {
      one: '{count} entrée supprimée',
      other: '{count} entrées supprimées',
    },
    deleteFailed: {
      one: "{count} entrée n'a pas pu être supprimée.",
      other: "{count} entrées n'ont pas pu être supprimées.",
    },
    allEntries: 'Toutes les entrées',
    lead: 'Brouillons, relectures, contenus planifiés et publiés de tous les types.',
    deleteN: 'Supprimer {count}',
    searchPlaceholder: 'Titre ou slug',
    contentType: 'Type de contenu',
    allTypes: 'Tous les types',
    nothingMatches: 'Aucun résultat',
    noEntries: 'Aucune entrée pour l’instant',
    createAn: 'Créer une entrée',
    tryFilter: 'Essayez un autre filtre.',
    noEntriesText:
      'Les entrées que vous créez apparaissent ici avec leur statut de workflow.',
    selectAll: 'Sélectionner toutes les entrées supprimables de cette page',
    title: 'Titre',
    live: 'En ligne',
    onlyOwn: 'Vous ne pouvez supprimer que vos propres entrées',
    changes: 'Modifications',
  },
  editor: {
    scheduleTitle: 'Planifier la publication',
    schedule: 'Planifier',
    scheduleText:
      "La version brouillon actuelle sera publiée automatiquement à l'heure choisie. Modifier l'entrée ensuite ne change pas ce qui sera publié.",
    publishAt: 'Publier le',
    restoredPublished: 'Version {n} restaurée et publiée',
    restoredDraft: 'Version {n} restaurée comme nouveau brouillon',
    versionN: 'Version {n}',
    restorePublish: 'Restaurer et publier',
    restoreDraft: 'Restaurer comme brouillon',
    summary: 'Résumé',
    schema: 'Schéma',
    restoreNote:
      "La restauration crée une nouvelle version à partir de cet état. L'historique n'est jamais réécrit.",
    removeLanguageTitle: 'Retirer {language} ?',
    removeLanguageText:
      "Ses traductions sont retirées de l'entrée à l'enregistrement, et la page n'est plus diffusée dans cette langue après la prochaine publication. Les versions précédentes les conservent.",
    discardTitle: 'Abandonner les modifications ?',
    discardText:
      'Vous avez des modifications non enregistrées. Quitter sans enregistrer ?',
    discard: 'Abandonner',
    created: 'Entrée créée',
    savedAs: 'Enregistrée en version {n}',
    conflict:
      "Quelqu'un d'autre a enregistré cette entrée. Rechargez pour voir ses modifications.",
    chooseType: 'Choisissez un type de contenu pour créer une entrée.',
    createDraft: 'Créer le brouillon',
    saveDraft: 'Enregistrer le brouillon',
    saved: 'Enregistré',
    fixFields: 'Veuillez corriger les champs signalés',
    actionFailed: "L'action n'a pas pu être effectuée",
    editingLanguage: "Langue d'édition",
    contentLanguage: 'Langue du contenu',
    languagesHelp:
      "Les langues dans lesquelles cette entrée existe. Le site ne l'affiche que dans ces langues ; la publication exige chaque champ obligatoire dans chacune d'elles.",
    publishing: 'Publication',
    liveChanges: 'En ligne · modifications en attente',
    draft: 'Brouillon',
    notPublished: 'Non publiée',
    publishedToast: 'Publiée',
    savePublish: 'Enregistrer et publier',
    republish: 'Republier',
    publish: 'Publier',
    submittedToast: 'Soumise à relecture',
    submit: 'Soumettre à relecture',
    returnedToast: 'Renvoyée en brouillon',
    returnToDraft: 'Renvoyer en brouillon',
    saveFirst: "Enregistrez d'abord",
    scheduleCancelled: 'Planification annulée',
    cancelSchedule: 'Annuler la planification',
    unpublishTitle: "Dépublier l'entrée ?",
    unpublishText:
      "Elle disparaîtra immédiatement de l'API de diffusion. Le brouillon est conservé.",
    unpublish: 'Dépublier',
    unpublishedToast: 'Dépubliée',
    preview: 'Aperçu',
    archiveTitle: "Archiver l'entrée ?",
    archiveText:
      "L'archivage dépublie l'entrée et la masque des vues par défaut des éditeurs.",
    archive: 'Archiver',
    archivedToast: 'Archivée',
    restoredToast: 'Restaurée',
    restore: 'Restaurer',
    deleteTitle: "Supprimer l'entrée ?",
    deleteText:
      '« {title} » et tout son historique de versions seront supprimés définitivement.',
    deletePublic: 'Sa page publique disparaît du site.',
    cannotUndo: 'Cette action est irréversible.',
    deleted: 'Entrée supprimée',
    slug: 'Slug',
    slugGenerated: 'Généré à partir du titre',
    slugHelp: "Utilisé dans les URL et l'API de diffusion.",
    fromTitle: 'Depuis le titre',
    changeNote: 'Note de modification',
    changeNotePlaceholder: "Qu'est-ce qui a changé ? (facultatif)",
    liveUrl: 'URL publique',
    noPublicPage:
      "Aucune page publique (slug ou catégorie manquant, ou le type n'est pas public)",
    history: 'Historique',
    liveLower: 'en ligne',
    draftSaved: 'Brouillon enregistré',
    noHistory: 'Pas encore d’historique.',
    scheduledFor: 'Planifiée pour {time}',
  },
  plugins: {
    plugin: 'Extension',
    continue: 'Continuer',
    frameNoValues:
      'Cette extension ne peut pas modifier les valeurs des champs.',
    frameAdminPaths: "Seuls les chemins d'administration peuvent être ouverts.",
    frameNoMedia: "Cette extension n'a pas reçu 'media.asset.read'.",
    requestFailed: 'Échec de la requête',
    isolated: 'Affiché par une extension dans un cadre isolé',
    extensionUnavailable: 'Extension indisponible',
    extensionUnavailableText:
      "Cette page d'extension n'est pas enregistrée, ou l'extension est désactivée.",
  },
  types: {
    titleField: 'Titre',
    createdToast: 'Type de contenu « {name} » créé',
    newType: 'Nouveau type de contenu',
    namePlaceholder: 'Article',
    apiKey: "Clé d'API",
    apiKeyHelp:
      "Utilisée dans les chemins d'API, p. ex. /api/v1/delivery/article. Non modifiable ensuite.",
    titleAdded: 'Un champ obligatoire « Titre » est ajouté pour commencer.',
    kicker: 'Modélisez vos contenus',
    lead: 'Définissez la structure de vos contenus. Les entrées sont validées par rapport à ces schémas à chaque enregistrement et publication.',
    none: 'Aucun type de contenu pour l’instant',
    createFirst: 'Créer votre premier type',
    noneText:
      "Les types de contenu décrivent la forme d'un article, d'une page ou d'un produit.",
    fields: 'Champs',
    one: 'Type de contenu',
    searchPlaceholder: 'Nom, clé API ou description',
  },
  fieldTypes: {
    TEXT: {
      label: 'Texte',
      description: 'Texte court, comme un titre ou un nom',
    },
    RICH_TEXT: {
      label: 'Texte enrichi',
      description: 'Texte long mis en forme (Markdown)',
    },
    NUMBER: {
      label: 'Nombre',
      description: 'Entiers ou décimaux avec bornes facultatives',
    },
    BOOLEAN: { label: 'Booléen', description: 'Interrupteur oui / non' },
    DATE: { label: 'Date', description: 'Date du calendrier' },
    DATETIME: { label: 'Date et heure', description: 'Date avec heure' },
    JSON: { label: 'JSON', description: 'Données structurées arbitraires' },
    MEDIA: {
      label: 'Média',
      description: 'Images, vidéos ou documents de la médiathèque',
    },
    RELATION: {
      label: 'Relation',
      description: "Références à d'autres entrées",
    },
    ENUM: { label: 'Choix', description: "Une valeur d'une liste fixe" },
    URL: { label: 'URL', description: 'Adresse web' },
  },
  builder: {
    required: 'obligatoire',
    localized: 'traduit',
    list: 'liste',
    images: 'Images',
    video: 'Vidéo',
    audio: 'Audio',
    defaultInvalid:
      'La valeur par défaut doit être un JSON valide (p. ex. "texte", 42, true ou ["a"]).',
    editField: 'Modifier le champ',
    addField: 'Ajouter un champ',
    saveField: 'Enregistrer le champ',
    locked:
      'Des entrées existent pour ce type. La clé, la liste et la traduction sont verrouillées ; seuls les changements de type compatibles sont possibles.',
    label: 'Libellé',
    keyHelp: 'Nom de la propriété dans les données de l’API.',
    requiredLabel: 'Obligatoire',
    localizedLabel: 'Traduit (une valeur par langue)',
    multiple: 'Valeurs multiples',
    helpText: "Texte d'aide",
    helpTextHelp: 'Affiché aux éditeurs sous le champ.',
    validation: 'Validation',
    minLength: 'Longueur min.',
    maxLength: 'Longueur max.',
    minimum: 'Minimum',
    maximum: 'Maximum',
    pattern: 'Motif (expression régulière)',
    integer: 'Nombres entiers uniquement',
    minItems: "Nombre min. d'éléments",
    maxItems: "Nombre max. d'éléments",
    options: 'Options',
    optionsHelp: 'Une option par ligne.',
    allowedTypes: 'Types de contenu autorisés',
    anyType: 'Laisser vide pour autoriser tous les types.',
    allowedMedia: 'Médias autorisés',
    anyMedia: 'Laisser vide pour autoriser tous les types de médias.',
    defaultValue: 'Valeur par défaut (JSON)',
    defaultHelp:
      'Appliquée aux nouvelles entrées. Exemples : "Sans titre", 0, true.',
    settingsSaved: 'Paramètres enregistrés',
    keysPermanent: 'Les clés sont définitives.',
    titleField: 'Champ titre',
    firstText: 'Premier champ texte',
    titleFieldHelp: "Affiché comme nom de l'entrée dans les listes.",
    slugFrom: 'Générer le slug depuis',
    noGenerate: 'Ne pas générer',
    slugRequired: 'Slug obligatoire pour publier',
    previewTemplate: "Modèle d'URL d'aperçu",
    previewHelp:
      'Variables : {slug}, {id}, {token}. Utilisé par l’action « Aperçu ».',
    publicUrls: 'URL publiques',
    reserved:
      "Le préfixe {prefix} est réservé par {owner}. Le modifier sort ces pages de l'espace d'URL de l'extension.",
    urlPrefix: "Préfixe d'URL",
    urlPrefixHelp:
      "Premier segment d'URL de ce type. Doit être unique ; les mots système et codes de langue sont réservés.",
    categoryFrom: 'Segment de catégorie depuis',
    noCategory: 'Pas de segment de catégorie',
    choice: 'choix',
    linkedSlug: "slug de l'entrée liée",
    categoryHelp:
      'Un champ de choix unique ou un lien vers une entrée de catégorie.',
    publicPages: 'Les entrées ont des pages publiques',
    servedAt:
      "Les pages sont servies à {path}, dans chaque langue où l'entrée existe. Les entrées sans slug n'ont pas de page publique. Changer le préfixe conserve les anciennes URL grâce à des redirections permanentes (308).",
    servedAtCategory:
      "Les pages sont servies à {path}, dans chaque langue où l'entrée existe. Les entrées sans slug ni catégorie n'ont pas de page publique. Changer le préfixe ou la catégorie conserve les anciennes URL grâce à des redirections permanentes (308).",
    widgets: 'Widgets de champ (extensions)',
    defaultEditor: 'Éditeur par défaut',
    saveSettings: 'Enregistrer les paramètres',
    fieldSaved: 'Champ enregistré',
    viewEntries: 'Voir les entrées',
    activated: 'Type de contenu activé',
    activate: 'Activer',
    archiveTitle: 'Archiver le type de contenu ?',
    archiveText:
      "Aucune nouvelle entrée ne peut être créée et la diffusion de ce type s'arrête. Les entrées existantes sont conservées.",
    deleteTitle: 'Supprimer le type de contenu ?',
    deleteWithEntries: {
      one: '« {name} » et son entrée ({count}, toutes versions et langues) seront supprimés définitivement. Les pages publiées disparaissent du site. Cette action est irréversible.',
      other:
        '« {name} » et ses {count} entrées (toutes versions et langues) seront supprimés définitivement. Les pages publiées disparaissent du site. Cette action est irréversible.',
    },
    deleteEmpty:
      '« {name} » sera supprimé définitivement. Cette action est irréversible.',
    deleted: 'Type de contenu supprimé',
    schemaVersion: 'Version du schéma {n}',
    noFields: 'Aucun champ',
    noFieldsText: 'Ajoutez des champs pour décrire ce type de contenu.',
    titleTag: 'TITRE',
    widget: 'widget {name}',
    moveUp: 'Monter',
    moveDown: 'Descendre',
    editX: 'Modifier {name}',
    removeX: 'Retirer {name}',
    removeFieldTitle: 'Retirer le champ ?',
    removeFieldUsed:
      '« {name} » disparaît de l’éditeur et de la diffusion. Les valeurs restent dans les versions précédentes.',
    removeFieldEmpty: '« {name} » sera retiré.',
    fieldRemoved: 'Champ retiré',
    namesTitle: 'Nom sur le site',
    namesHelp:
      'Le nom de ce type dans chaque langue (navigation, libellés). Vide : le nom ci-dessus.',
  },
  media: {
    saved: 'Détails du média enregistrés',
    details: 'Détails du média',
    deleteTitle: 'Supprimer le fichier ?',
    deleteText:
      '« {name} » est retiré du stockage et ne se charge plus nulle part. Cette action est irréversible.',
    deleted: 'Fichier supprimé',
    file: 'Fichier',
    size: 'Taille',
    uploaded: 'Téléversé',
    checksum: 'Somme de contrôle',
    altText: 'Texte alternatif',
    altHelp:
      "Décrivez l'image pour les lecteurs d'écran. Requis pour un contenu accessible.",
    visibility: 'Visibilité',
    public: 'Public — URL stable, mise en cache possible',
    private: 'Privé — liens signés de courte durée uniquement',
    linkCopied: 'Lien copié',
    copyLink: 'Copier le lien',
    download: 'Télécharger',
    kicker: 'Médiathèque',
    lead: 'Images, vidéos, audio et documents. Les fichiers sont stockés en stockage objet et vérifiés par leur signature.',
    searchPlaceholder: 'Nom de fichier, titre ou texte alternatif',
    documents: 'Documents',
    none: 'Aucun média pour l’instant',
    noneText: 'Téléversez des fichiers pour les utiliser dans vos contenus.',
    openX: 'Ouvrir {name}',
    missingAlt: 'Texte alternatif manquant',
    noAlt: 'SANS ALT',
    selectMedia: 'Sélectionner des médias',
    selectFile: 'Sélectionner un fichier',
    useSelected: 'Utiliser la sélection',
    pickerSearch: 'Rechercher par nom de fichier ou texte alternatif',
    searchMedia: 'Rechercher des médias',
    noneFound: 'Aucun média trouvé',
    uploadedX: '{name} téléversé',
    drop: '{strong} ou cliquez pour parcourir',
    dropStrong: 'Déposez des fichiers ici',
    dropHelp:
      'Images, vidéos, audio et PDF. Le type de fichier est vérifié au téléversement.',
  },
  pluginList: {
    kicker: 'Étendre',
    lead: "Les extensions ne sont pas fiables tant qu'un administrateur n'a pas examiné leurs capacités, puis ne les a pas installées et activées. Elles s'exécutent isolées du cœur du CMS.",
    invalid: '{count} paquet(s) non valide(s) : {paths}',
    scanned: 'Registre analysé : {count} paquet(s)',
    scan: 'Analyser le registre',
    none: 'Aucune extension trouvée',
    noneText:
      "Placez les paquets d'extension (avec un cms-plugin.json) dans le dossier du registre, puis analysez le registre.",
    capabilities: 'Capacités',
    health: 'État',
    update: 'Mise à jour : {version}',
    signed: 'Signée',
    badSignature: 'Signature invalide',
    packageMissing: 'Paquet manquant',
    granted: '{granted} / {requested} accordées',
    noSettings: "Cette extension n'a pas de paramètres.",
    saveConfig: 'Enregistrer la configuration',
    updates: 'Mise à jour disponible',
    searchPlaceholder: 'Nom, clé ou éditeur',
  },
  pluginDetail: {
    features: 'Fonctionnalités',
    featuresText:
      "Les drapeaux de fonctionnalité activent ou désactivent des parties de l'extension pour tous. Ils n'agissent que lorsque l'extension est activée et n'accordent jamais d'autorisations.",
    installFirst: "Installez l'extension pour gérer ses fonctionnalités.",
    turnedOn: '{key} activé',
    turnedOff: '{key} désactivé',
    inactive: "inactif tant que l'extension est désactivée",
    changed: 'modifié {time}',
    installed: '{name} installée',
    updatedTo: '{name} mise à jour en {version}',
    installX: 'Installer {name}',
    updateX: 'Mettre à jour {name}',
    approveInstall: 'Approuver et installer',
    approveUpdate: 'Approuver et mettre à jour',
    installFailed: "L'extension n'a pas pu être installée",
    unsigned:
      "Ce paquet n'est pas signé par un éditeur de confiance. N'installez que des extensions dont vous avez examiné le code source.",
    requests:
      "{name} {version} demande les capacités ci-dessous. Décochez ce que vous ne souhaitez pas accorder — l'extension ne peut utiliser que ce que vous approuvez, et vous pouvez révoquer les autorisations à tout moment.",
    granted: 'Accordée',
    migrationsWillRun:
      "{count} migration(s) s'exécuteront dans l'environnement isolé des extensions et seront consignées dans le journal d'audit.",
    uninstallX: 'Désinstaller {name}',
    uninstalled: 'Extension désinstallée',
    uninstall: 'Désinstaller',
    uninstallText:
      "Toutes les capacités accordées sont révoquées. Le contenu créé par l'extension via l'API du CMS (par exemple des types de contenu) n'est pas supprimé.",
    pluginData: "Données de l'extension",
    keepData:
      'Conserver les données et la configuration (réinstallation ultérieure)',
    deleteData: 'Supprimer définitivement les données et la configuration',
    typeKey: 'Saisissez {key} pour confirmer',
    disableX: 'Désactiver {name}',
    disabledToast: 'Extension désactivée',
    disable: 'Désactiver',
    disableText:
      "Les abonnements aux événements, les tâches et les extensions d'administration s'arrêtent immédiatement. Les données sont conservées.",
    reason: 'Motif (facultatif)',
    incident: 'Incident de sécurité — bloquer la réactivation automatique',
    install: 'Installer',
    updateTo: 'Mettre à jour en {version}',
    enabledToast: '{name} activée',
    enable: 'Activer',
    deleteTitle: "Supprimer l'enregistrement de l'extension ?",
    deleteGone:
      "L'enregistrement de « {name} » (son paquet a disparu) et toutes les données conservées sont supprimés définitivement.",
    deleteRegistry:
      "L'enregistrement de « {name} » et toutes les données conservées sont supprimés définitivement. Son paquet est toujours dans le registre ; il réapparaîtra comme découvert à la prochaine analyse.",
    deleted: 'Extension supprimée',
    lastError: 'Dernière erreur',
    notCompatible: 'Non compatible',
    overview: "Vue d'ensemble",
    configuration: 'Configuration',
    migrations: 'Migrations',
    package: 'Paquet',
    installedLabel: 'Installée',
    notInstalled: 'Non installée',
    available: 'Disponible',
    publisher: 'Éditeur',
    license: 'Licence',
    defaultLanguage: '{language} (par défaut)',
    languagesHelp:
      "Les écrans de l'extension utilisent la langue de l'administration si elle figure ici, sinon sa langue par défaut.",
    signature: 'Signature',
    integrity: 'Intégrité',
    homepage: 'Site web',
    backendService: 'Service backend',
    bound: 'connecté',
    notBound: 'non connecté',
    permissionsAdded: 'Autorisations ajoutées',
    defaultRoles: 'par défaut : administrateur, {roles}',
    runtime: 'Exécution',
    lastCheck: 'Dernière vérification',
    backend: 'Backend',
    adminUi: "Interface d'administration",
    events: 'Événements',
    jobs: 'Tâches',
    every: '{id} (toutes les {seconds} s)',
    dependencies: 'Dépendances',
    optional: 'facultatif',
    notInstalledLower: 'non installée',
    missing: 'manquante',
    grants: 'Capacités accordées',
    grantsText:
      "Refus par défaut : une capacité demandée n'agit qu'une fois accordée. La révocation prend effet en quelques secondes, y compris pour les processus en cours.",
    grantedAt: 'Accordée {time}',
    noLongerRequested: 'Plus demandée',
    notGranted: 'Non accordée',
    revokedToast: 'Capacité révoquée',
    grantedToast: 'Capacité accordée',
    revoke: 'Révoquer',
    grant: 'Accorder',
    configSaved: 'Configuration enregistrée',
    migrationsDone: 'Migrations terminées',
    retry: 'Réessayer',
    noMigrations: 'Aucune migration déclarée.',
    migration: 'Migration',
    applied: 'Appliquée',
  },
  users: {
    permissionsCount: '{count} autorisations',
    created: 'Utilisateur créé',
    invite: 'Inviter un utilisateur',
    createUser: "Créer l'utilisateur",
    initialPassword: 'Mot de passe initial',
    passwordHelp:
      'Au moins 12 caractères avec trois parmi : minuscule, majuscule, chiffre, symbole. Transmettez-le de façon sûre.',
    updated: 'Utilisateur mis à jour',
    deleteTitle: "Supprimer l'utilisateur ?",
    deleteText:
      '{name} ({email}) est déconnecté partout et supprimé définitivement avec toutes ses sessions et attributions de rôles. Le contenu créé est conservé. Cette action est irréversible.',
    deleted: 'Utilisateur supprimé',
    disableTitle: "Désactiver l'utilisateur ?",
    disableText:
      "{name} est déconnecté partout et ne peut plus se connecter jusqu'à sa réactivation.",
    reenabled: 'Utilisateur réactivé',
    unlock: 'Déverrouiller',
    lastSignIn: 'Dernière connexion',
    resetPassword: 'Réinitialiser le mot de passe',
    newPassword: 'Nouveau mot de passe',
    resetDone: 'Mot de passe réinitialisé ; toutes les sessions sont fermées',
    twoFactor: 'Authentification à deux facteurs',
    twoFactorOn: 'Activée',
    twoFactorOff: 'Désactivée',
    resetTwoFactor: 'Réinitialiser la 2FA',
    resetTwoFactorTitle: 'Réinitialiser l’authentification à deux facteurs ?',
    resetTwoFactorText:
      '{name} a perdu son téléphone et ses codes de récupération ? Le mot de passe seul suffira pour se connecter jusqu’à ce que la 2FA soit réactivée. L’opération est consignée dans le journal d’audit.',
    resetTwoFactorDone:
      'L’authentification à deux facteurs a été réinitialisée',
    reset: 'Réinitialiser',
    lead: 'Les personnes qui peuvent se connecter à GX-CMS. L’accès est accordé par les rôles.',
    add: 'Ajouter un utilisateur',
    searchPlaceholder: 'Nom ou e-mail',
    anyStatus: 'Tous les statuts',
    none: 'Aucun utilisateur trouvé',
  },
  roles: {
    audit: 'Audit',
    newRole: 'Nouveau rôle',
    lead: 'Les rôles regroupent des autorisations. Chaque API vérifie les autorisations côté serveur à chaque requête ; les changements s’appliquent en quelques secondes.',
    users: { one: '{count} utilisateur', other: '{count} utilisateurs' },
    system: 'Système',
    deleteTitle: 'Supprimer le rôle ?',
    deleteText:
      '{count} utilisateur(s) perdent les autorisations de « {name} ».',
    saved: 'Autorisations enregistrées',
    adminAll:
      'Le rôle administrateur détient toujours toutes les autorisations.',
    created: 'Rôle créé — choisissez maintenant ses autorisations',
  },
  permissions: {
    'user.read': 'Voir les utilisateurs et les rôles',
    'user.manage':
      'Créer, modifier et désactiver des utilisateurs ; gérer les rôles',
    'user.delete': 'Supprimer définitivement des comptes utilisateur',
    'content.type.read': 'Voir les types de contenu et leurs champs',
    'content.type.manage':
      'Créer et modifier les types de contenu et leurs champs',
    'content.entry.read': 'Voir les entrées, brouillons et révisions',
    'content.entry.create': 'Créer des entrées',
    'content.entry.update':
      'Modifier les brouillons, soumettre à relecture et archiver des entrées',
    'content.entry.publish': 'Publier, dépublier et planifier des entrées',
    'content.entry.rollback':
      'Restaurer des entrées à des révisions précédentes',
    'content.entry.delete': "Supprimer définitivement n'importe quelle entrée",
    'content.entry.delete.own': 'Supprimer définitivement ses propres entrées',
    'content.type.delete':
      'Supprimer des types de contenu, y compris toutes leurs entrées',
    'media.read': 'Voir la médiathèque',
    'media.upload': 'Téléverser et modifier des médias',
    'media.delete': "Supprimer n'importe quel média",
    'media.delete.own': 'Supprimer ses propres médias',
    'plugin.read': 'Voir les extensions',
    'plugin.install':
      'Découvrir, installer et désinstaller des extensions ; accorder des capacités',
    'plugin.enable': 'Activer et désactiver des extensions',
    'plugin.configure': 'Configurer des extensions',
    'plugin.delete': 'Retirer des enregistrements du registre des extensions',
    'plugin.feature.manage':
      'Activer et désactiver les drapeaux de fonctionnalité des extensions',
    'audit.read': "Consulter le journal d'audit",
    'mail.settings.manage':
      'Manage the e-mail (SMTP) settings of the CMS and plugins',
    'mail.send': 'Send e-mail through the CMS mail settings (plugins)',
    'backup.export':
      'Télécharger une sauvegarde de toutes les données et de tous les médias, y compris les utilisateurs et les réglages',
    'backup.import':
      'Remplacer toutes les données et tous les médias par une sauvegarde',
    'site.settings.manage':
      'Modifier le nom, la description, les langues et les coordonnées du site web',
  },
  audit: {
    lead: "Un registre en ajout seul des événements importants pour la sécurité et l'activité, sur tous les services.",
    action: 'Action',
    actionPlaceholder: 'p. ex. content.entry.published',
    resource: 'Ressource',
    any: 'Tous',
    outcome: 'Résultat',
    from: 'Du',
    to: 'Au',
    none: 'Aucun événement',
    noneText: 'Rien ne correspond à ces filtres.',
    time: 'Heure',
    actor: 'Acteur',
    event: "Événement d'audit",
    source: 'Source',
    correlation: 'Corrélation',
    eventId: "ID de l'événement",
    metadata: 'Métadonnées',
  },
  mfa: {
    title: 'Vérification en deux étapes',
    help: 'Saisissez le code à 6 chiffres de votre application d’authentification, ou l’un de vos codes de récupération.',
    code: 'Code',
    verify: 'Vérifier',
    back: 'Retour à la connexion',
    panel: 'Authentification à deux facteurs',
    off: 'Désactivée : votre mot de passe suffit pour vous connecter. Activée, elle demande aussi un code d’une application d’authentification sur votre téléphone.',
    on: 'Activée depuis le {date}. Codes de récupération restants : {count}.',
    turnOn: 'Activer',
    scan: 'Scannez le code QR avec une application d’authentification (par exemple Google Authenticator, Microsoft Authenticator ou 1Password), ou saisissez la clé. Puis entrez le code affiché.',
    key: 'Clé',
    appCode: 'Code de l’application',
    enabled: 'L’authentification à deux facteurs est activée',
    recoveryTitle: 'Vos codes de récupération',
    recoveryHelp:
      'Chaque code permet une connexion si vous perdez votre téléphone. Enregistrez-les maintenant en lieu sûr : ils ne seront plus affichés.',
    copy: 'Copier les codes',
    copied: 'Codes copiés',
    saved: 'Je les ai enregistrés',
    codeHelp: 'Un code de l’application ou un code de récupération',
    turnOff: 'Désactiver',
    disabled: 'L’authentification à deux facteurs est désactivée',
    newCodes: 'Nouveaux codes de récupération',
    newCodesDone:
      'Nouveaux codes de récupération ; les anciens ne fonctionnent plus',
  },
  settings: {
    profileUpdated: 'Profil mis à jour',
    mismatch: 'Les nouveaux mots de passe ne correspondent pas.',
    passwordChanged:
      'Mot de passe modifié. Les autres sessions ont été fermées.',
    kicker: 'Votre compte',
    profile: 'Profil',
    emailHelp: 'Demandez à un administrateur de modifier votre e-mail.',
    saveProfile: 'Enregistrer le profil',
    currentPassword: 'Mot de passe actuel',
    passwordHelp:
      'Au moins 12 caractères avec trois parmi : minuscule, majuscule, chiffre, symbole.',
    confirmPassword: 'Confirmer le nouveau mot de passe',
    changePassword: 'Changer le mot de passe',
    appearance: 'Apparence',
    design: 'Thème',
    designHelp:
      'Modifie l’apparence de l’admin et des pages des plugins pour vous, dans ce navigateur. Le mode clair ou sombre se choisit ci-dessous.',
    designs: {
      gxlabs: {
        name: 'GXLabs (par défaut)',
        about: 'Noir et blanc avec un accent cyan',
      },
      apple: { name: 'Apple', about: 'Calme, arrondi, style macOS' },
      aurora: { name: 'Aurora', about: 'Violet, fuchsia et cyan' },
      sunset: { name: 'Sunset', about: 'Corail, mandarine et rose' },
      lagoon: { name: 'Lagoon', about: 'Sarcelle, émeraude et bleu ciel' },
      neon: { name: 'Neon', about: 'Magenta et cyan, idéal en mode sombre' },
    },
    theme: 'Thème',
    light: 'Clair',
    dark: 'Sombre',
    system: 'Comme le système',
    languageHelp:
      "L'administration est disponible dans les langues du site. Les écrans d'extension qui ne prennent pas en charge votre langue utilisent leur langue par défaut.",
    access: 'Accès',
    permissions: 'Autorisations',
  },
  website: {
    kicker: 'Administration',
    title: 'Site web',
    lead: 'Ce que le site web public affiche de lui-même : son nom, sa description, ses langues et ses coordonnées. L’administration du CMS n’utilise pas ces paramètres.',
    general: 'Général',
    name: 'Nom du site web',
    nameHelp:
      'Dans l’onglet du navigateur, dans les résultats de recherche et dans le pied de page.',
    descriptionIn: 'Description ({language})',
    descriptionHelp:
      'Affichée dans les résultats de recherche et lorsqu’une page du site web est partagée.',
    languages: 'Langues',
    languagesLabel: 'Langues du site web',
    languagesHelp:
      'Le site web ne propose que celles-ci. Les rédacteurs peuvent toujours écrire dans toutes les langues du CMS : le contenu apparaît sur le site web dès que sa langue est activée ici.',
    defaultLanguage: 'Langue par défaut',
    defaultLanguageHelp:
      'Les visiteurs qui ouvrent l’adresse sans langue arrivent ici.',
    contact: 'Contact',
    contactLead:
      'Dans le bandeau de contact et le pied de page de chaque page. Les champs vides sont masqués.',
    email: 'E-mail',
    phone: 'Téléphone',
    address: 'Adresse',
    mapQuery: 'Carte',
    mapQueryHelp:
      'Texte de recherche Google Maps de la carte en bas de chaque page, p. ex. le nom et l’adresse de l’entreprise. Vide = pas de carte.',
    social: 'Réseaux sociaux',
    fonts: 'Polices',
    adobeFontsKit: 'ID du kit Adobe Fonts',
    adobeFontsKitHelp:
      'Le kit avec les polices du site web (autorisez les domaines du site web dans Adobe Fonts). Vide = polices de remplacement gratuites.',
    save: 'Enregistrer',
    saved:
      'Paramètres du site web enregistrés. Le site web les affiche en moins d’une minute.',
    lastSaved: 'Dernier enregistrement : {when}',
    neverSaved: 'Pas encore enregistré.',
  },
  backup: {
    kicker: 'Administration',
    title: 'Sauvegarde',
    lead: 'Téléchargez tout le contenu de ce site dans un seul fichier ZIP, ou remplacez-le par un tel fichier : pour en garder une copie ou pour déménager le site sur un autre serveur.',
    exportTitle: 'Télécharger une sauvegarde',
    exportLead:
      'Le fichier ZIP contient les données du CMS (contenus, utilisateurs et rôles, réglages, plugins, CRM, messages de contact, journal d’audit) en SQL, ainsi que tous les fichiers médias. Les données propres à NEAREE (profils, likes, matchs, discussions) n’y sont pas encore.',
    exportSecret:
      'Il contient des données personnelles, des empreintes de mots de passe et des secrets chiffrés. Conservez-le comme un mot de passe.',
    exportKeys:
      'Les secrets enregistrés dans l’admin (mots de passe SMTP, clés de paiement) sont chiffrés avec les clés serveur PLUGIN_SECRETS_KEY et MAIL_SECRETS_KEY. Ils ne restent lisibles que là où les mêmes clés sont définies.',
    download: 'Télécharger la sauvegarde',
    preparing: 'Préparation…',
    downloadStarted:
      'Le téléchargement a commencé. Pour un grand site, il prend un moment.',
    importTitle: 'Importer une sauvegarde',
    importLead:
      'Envoyez une sauvegarde faite par GX-CMS. Vous verrez ce qu’elle contient avant que quoi que ce soit ne change.',
    importReplaces:
      'Une importation remplace toutes les données et tous les fichiers médias de ce site. Les utilisateurs, mots de passe et rôles viennent de la sauvegarde : vous vous connectez ensuite avec un compte de la sauvegarde.',
    chooseFile: 'Choisir un fichier ZIP',
    uploading: 'Envoi… {percent} %',
    checking: 'Vérification de la sauvegarde…',
    backupOf: 'Sauvegarde de {source}',
    unknownSource: 'site inconnu',
    createdAt: 'Faite le {date} avec GX-CMS {version}',
    part: 'Partie',
    rows: 'Enregistrements',
    mediaFiles: 'Fichiers médias',
    mediaSummary: '{files} fichiers, {size}',
    canImport: 'Cette sauvegarde peut être importée.',
    cannotImport: 'Cette sauvegarde ne peut pas être importée ici :',
    notes: 'Bon à savoir :',
    replace: 'Remplacer toutes les données…',
    discard: 'Abandonner l’envoi',
    discarded: 'Envoi abandonné',
    confirmTitle: 'Remplacer toutes les données ?',
    confirmMessage:
      'Tous les contenus, utilisateurs, réglages et données des plugins de ce site seront remplacés par la sauvegarde du {date}. Une copie des données actuelles est conservée jusqu’à la fin de l’importation et restaurée si celle-ci échoue. Saisissez {word} pour continuer.',
    confirmWord: 'REMPLACER',
    confirmLabel: 'Remplacer toutes les données',
    running: 'Importation…',
    steps: {
      check: 'Vérification',
      media: 'Copie des fichiers médias ({count})',
      'safety-copy': 'Copie des données actuelles',
      database: 'Chargement : {part}',
      rollback:
        'Une erreur est survenue : restauration des données précédentes',
      done: 'Terminé',
    } as Record<string, string>,
    succeeded:
      'La sauvegarde a été importée : {rows} enregistrements et {files} fichiers médias. Connectez-vous avec un compte de la sauvegarde.',
    signIn: 'Se connecter',
    failed: 'L’importation a échoué : {error}',
    rolledBack:
      'Les données précédentes ont été restaurées ; rien n’a changé, sauf de nouveaux fichiers médias.',
    notRolledBack:
      'Les données sont peut-être incomplètes. Importez de nouveau la sauvegarde, ou une autre.',
    statusLost:
      'Vous avez été déconnecté pendant l’importation. Sa progression s’affiche ci-dessous.',
    parts: {
      'identity-service': 'Utilisateurs, rôles et réglages e-mail',
      'content-service': 'Contenus et types de contenu',
      'media-service': 'Médiathèque',
      'plugin-service': 'Plugins et leurs réglages',
      'audit-service': 'Journal d’audit',
      'crm-service': 'CRM',
      'webshop-service': 'Boutique en ligne',
      'appointments-service': 'Prise de rendez-vous',
      'contact-service': 'Messages de contact',
      'mobile-app-service': 'Application mobile',
    } as Record<string, string>,
    issues: {
      format_unsupported:
        'Elle a été faite par un GX-CMS plus récent (format de sauvegarde {version}).',
      manifest_invalid:
        'Ce n’est pas une sauvegarde GX-CMS, ou le fichier est endommagé.',
      file_missing: 'Une partie de la sauvegarde manque ({part}).',
      service_unavailable:
        '{part} : cette partie ne fonctionne pas sur ce site. Activez-la d’abord.',
      service_not_in_backup:
        '{part} : absente de la sauvegarde ; ses données actuelles sont conservées.',
      migrations_differ_older:
        '{part} : la sauvegarde a été faite par une version plus ancienne de GX-CMS. Importez-la dans cette version, puis mettez à jour.',
      migrations_differ_newer:
        '{part} : la sauvegarde a été faite par une version plus récente de GX-CMS. Mettez d’abord ce site à jour.',
      migrations_differ_different:
        '{part} : la sauvegarde a été faite par une autre version de GX-CMS.',
      key_differs:
        '{part} : ce serveur a une autre {key}. Les secrets enregistrés dans l’admin (mots de passe, clés de paiement) seront illisibles après l’importation ; saisissez-les de nouveau, ou définissez d’abord la même clé.',
    } as Record<string, string>,
  },
  errors: {
    generic: 'Une erreur est survenue.',
    offline: 'GX-CMS est injoignable. Vérifiez votre connexion.',
    uploadFailed: 'Échec du téléversement',
    uploadNetwork: 'Échec du téléversement : erreur réseau.',
  },
}
